import { 
  ATTRIBUTE_NAME, 
  LOCAL_STORAGE_KEY, 
  SIDEBAR_CHATS_CONTAINER_SCROLL_LOCAL_STORAGE_KEY
} from "./constants"

declare global {
  interface Window {
    initSidebar: () => void
    setSidebarChatSectionScrollPosition: () => void
  }
}

window.initSidebar = () => {
  const html = document.documentElement
  if (!html) {
    return
  }

  const isClosed = localStorage.getItem(LOCAL_STORAGE_KEY)
  if (isClosed) {
    html.setAttribute(ATTRIBUTE_NAME, "")
  }
}

window.setSidebarChatSectionScrollPosition = () => {
  const chatContainer = document.querySelector(".sidebar__chats-section .sidebar__menu")

  if (!chatContainer) {
    return
  }

  const savedScroll = localStorage.getItem(SIDEBAR_CHATS_CONTAINER_SCROLL_LOCAL_STORAGE_KEY)
  if (savedScroll !== null) {
    chatContainer.scrollTop = parseInt(savedScroll, 10)
    localStorage.removeItem(SIDEBAR_CHATS_CONTAINER_SCROLL_LOCAL_STORAGE_KEY)
  }
}
